import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var CommentaryService = /** @class */ (function () {
    function CommentaryService(http) {
        this.http = http;
    }
    CommentaryService.prototype.addCommentary = function (dealerId, commentary) {
        var headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        var url = 'dealers/' + dealerId + '/comments/';
        return this.http
            .post(url, commentary, { headers: headers });
    };
    CommentaryService.ngInjectableDef = i0.defineInjectable({ factory: function CommentaryService_Factory() { return new CommentaryService(i0.inject(i1.HttpClient)); }, token: CommentaryService, providedIn: "root" });
    return CommentaryService;
}());
export { CommentaryService };
